// require('bootstrap');
global.$ = global.jQuery = require('jquery'); // for jquery in views
var defaultFontSize = 16;
var currentFontSize = defaultFontSize;

$(document).ready(function () {
    $(".zoom-row").click(function (event) {
        if( $(this).hasClass('zoom-in') )
        {
            if( currentFontSize < 20 )
            {
                currentFontSize = currentFontSize + 1;
                $(".item-text-content").css("font-size", currentFontSize + "px");
                $(".item-text-content").find("span").css("font-size", currentFontSize + "px");
                $(".item-text-content").find("strong").css("font-size", currentFontSize + "px");
                $(".item-text-content").find("i").css("font-size", currentFontSize + "px");
            }

        }
        else if( $(this).hasClass('zoom-out') )
        {
            if( currentFontSize > 11 )
            {
                currentFontSize = currentFontSize - 1;
                $(".item-text-content").css("font-size", currentFontSize + "px");
                $(".item-text-content").find("span").css("font-size", currentFontSize + "px");
                $(".item-text-content").find("strong").css("font-size", currentFontSize + "px");
                $(".item-text-content").find("i").css("font-size", currentFontSize + "px");
            }
        }

    });
})
